import ButtonIconH from "../components/ButtonIconH";
import DataTable from "react-data-table-component";
import { useEffect, useState } from "react";
import { userData, inputOnEnter, formatValueUnit } from "../js/utils";
import { axisStyle, barColors } from "../js/barChartStyle";
import { post } from "../js/post";
import moment from "moment";
import "moment/locale/es";
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Bar,
  BarChart,
  Rectangle,
} from "recharts";
import { salesSummaryTable } from "../js/tableColumns";
import { TabSelector } from "./TabSelector";
import { DashboardSalesPanelSalesView } from "./DashboardSalesPanelSalesView";
import { DashboardSalesPanelStatsView } from "./DashboardSalesPanelStatsView";
import { barChartMargin } from "../js/barChartStyle";

export function DashboardSalesPanel({
  openCashPopup,
  createPopupQuestion,
  removePopupQuestion,
}) {
  moment.locale("es");
  const [selectedSalesOptic, setSelectedSalesOptic] = useState({
    id: "",
    name: "",
  });
  const [cashClosureOpticsList, setCashClosureOpticsList] = useState([]);
  const [cashClosureDate, setCashClosureDate] = useState(
    moment().format("YYYY-MM-DD"),
  );
  const [cashClosureData, setCashClosureData] = useState([]);
  const [selectedTimeView, setSelectedTimeView] = useState("Vista mensual");
  const [selectedPanelView, setSelectedPanelView] = useState("Ventas");
  const [currentMonth, setCurrentMonth] = useState(moment());
  const [currentYear, setCurrentYear] = useState(moment());
  const [expandPanel, setExpandPanel] = useState(true);

  const customTooltip = ({ payload, label, active }) => {
    if (!active || !payload || !payload.length) return null;

    return (
      <div
        className="recharts-default-tooltip"
        style={{
          margin: "0px",
          padding: "10px",
          backgroundColor: "rgb(255, 255, 255)",
          border: "1px solid rgb(204, 204, 204)",
          whiteSpace: "nowrap",
          borderRadius: "4px",
          boxShadow: "rgba(0, 0, 0, 0.1) 0px 2px 8px",
        }}
      >
        <p className="recharts-tooltip-label">{`${
          selectedTimeView === "Vista mensual" ? "Día" : "Mes"
        }: ${label}`}</p>
        <ul
          className="recharts-tooltip-item-list"
          style={{
            padding: "0px",
            margin: "0px",
            listStyleType: "none",
          }}
        >
          <li
            className="recharts-tooltip-item"
            style={{
              color: barColors.blue,
            }}
          >
            <span className="recharts-tooltip-item-value">
              {`Valor: ${formatValueUnit(payload[0].value, "€")}`}
            </span>
          </li>
        </ul>
      </div>
    );
  };

  const updatedColumns = salesSummaryTable.map((col) => {
    if (col.name === "") {
      return {
        ...col,
        cell: (row) =>
          row.idOptica ? (
            <button
              tabIndex={-1}
              onClick={(e) => {
                e.stopPropagation();
                openCashPopup(
                  row.idOptica,
                  "estandar",
                  true,
                  cashClosureDate,
                  cashClosureDate,
                  -1,
                  row.nombreOptica,
                  "",
                );
                setSelectedSalesOptic({
                  id: row.idOptica,
                  name: row.nombreOptica,
                });
              }}
            >
              Ver más
            </button>
          ) : (
            ""
          ),
      };
    }

    return col;
  });

  const conditionalRowStyles = [
    {
      when: (row) => row.idOptica === selectedSalesOptic.id,
      classNames: ["selected-optic-row"],
    },
  ];

  async function getCashClosures() {
    const response = await post(
      "support-extra/dashboard/ObtenerCierresCaja.php",
      {
        token: userData.token,
        fecha: cashClosureDate,
      },
    );
    setCashClosureOpticsList(response);
    if (response.length > 0) {
      setSelectedSalesOptic({
        id: response[0].idOptica,
        name: response[0].nombreOptica,
      });
    } else {
      setSelectedSalesOptic({ id: "", name: "" });
    }
  }

  async function getMonthlyCashClosureCharts() {
    const month = moment(currentMonth).month() + 1;
    const year = moment(currentMonth).year();
    const response = await post(
      "support-extra/dashboard/ObtenerCierresCajaGraficoMensual.php",
      {
        token: userData.token,
        idOptica: selectedSalesOptic.id,
        mes: month,
        ano: year,
      },
    );
    setCashClosureData(
      response.map((e, i) => {
        return {
          name: i + 1,
          total: e,
        };
      }),
    );
  }

  async function getAnnualCashClosureCharts() {
    const year = moment(currentYear).year();
    const response = await post(
      "support-extra/dashboard/ObtenerCierresCajaGraficoAnual.php",
      {
        token: userData.token,
        idOptica: selectedSalesOptic.id,
        ano: year,
      },
    );
    setCashClosureData(
      response.map((e, i) => {
        return {
          name: i + 1,
          total: e,
        };
      }),
    );
  }

  useEffect(() => {
    getCashClosures();
  }, [cashClosureDate]);

  useEffect(() => {
    if (selectedTimeView === "Vista mensual") getMonthlyCashClosureCharts();
  }, [currentMonth, selectedSalesOptic, selectedTimeView]);

  useEffect(() => {
    if (selectedTimeView === "Vista anual") getAnnualCashClosureCharts();
  }, [currentYear, selectedSalesOptic, selectedTimeView]);

  return (
    <div className="patient-search-content dashboard-bg">
      <div className="opt-table-title">Resumen de ventas</div>
      <div className="dashboard-content-data">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            gap: 40,
          }}
        >
          <div className="dashboard-summary-table thin-rounded-border">
            <div className="data-field">
              <button
                className="incdec-btn"
                tabIndex={-1}
                onClick={() => {
                  setCashClosureDate((prev) =>
                    moment(prev).subtract(1, "day").format("YYYY-MM-DD"),
                  );
                }}
              >
                {"<"}
              </button>
              <input
                type="date"
                max="9999-12-31"
                className="input-field"
                value={cashClosureDate}
                onChange={(e) => {
                  setCashClosureDate(e.target.value);
                }}
                onKeyUp={(e) => inputOnEnter(e)}
                tabIndex={-1}
              ></input>
              <button
                className="incdec-btn"
                tabIndex={-1}
                onClick={() => {
                  setCashClosureDate((prev) =>
                    moment(prev).add(1, "day").format("YYYY-MM-DD"),
                  );
                }}
              >
                {">"}
              </button>
            </div>
            <DataTable
              columns={updatedColumns}
              data={cashClosureOpticsList}
              className="custom-datatable dashboard-custom-table"
              noDataComponent="No hay datos disponibles."
              conditionalRowStyles={conditionalRowStyles}
              onRowClicked={(row) => {
                setSelectedSalesOptic({
                  id: row.idOptica,
                  name: row.nombreOptica,
                });
              }}
            />
            {cashClosureOpticsList.length > 0 && (
              <DataTable
                columns={updatedColumns}
                data={[
                  {
                    idOptica: "",
                    nombreOptica: "",
                    total: cashClosureOpticsList.reduce(
                      (acc, e) => acc + e.total,
                      0,
                    ),
                  },
                ]}
                className="custom-datatable summary-row no-header-datatable"
              />
            )}
          </div>
          <div className="dashboard-summary-chart thin-rounded-border">
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                alignItems: "center",
                justifyContent: "space-around",
              }}
            >
              <span
                className="dashboard-section-or-title"
                style={{ maxWidth: "300px" }}
              >
                {selectedSalesOptic.id + " - " + selectedSalesOptic.name}
              </span>
              {selectedTimeView === "Vista mensual" && (
                <div className="data-field">
                  <button
                    className="incdec-btn"
                    tabIndex={-1}
                    onClick={() => {
                      setCurrentMonth((prev) =>
                        moment(prev).subtract(1, "month"),
                      );
                    }}
                  >
                    {"<"}
                  </button>
                  <span style={{ width: "130px", textAlign: "center" }}>
                    {currentMonth
                      .format("MMMM")
                      .replace(/^./, (m) => m.toUpperCase()) +
                      " " +
                      currentMonth.format("YYYY")}
                  </span>
                  <button
                    className="incdec-btn"
                    tabIndex={-1}
                    onClick={() => {
                      setCurrentMonth((prev) => moment(prev).add(1, "month"));
                    }}
                  >
                    {">"}
                  </button>
                </div>
              )}
              {selectedTimeView === "Vista anual" && (
                <div className="data-field">
                  <button
                    className="incdec-btn"
                    tabIndex={-1}
                    onClick={() => {
                      setCurrentYear((prev) =>
                        moment(prev).subtract(1, "year"),
                      );
                    }}
                  >
                    {"<"}
                  </button>
                  <span style={{ width: "130px", textAlign: "center" }}>
                    {currentYear.format("YYYY")}
                  </span>
                  <button
                    className="incdec-btn"
                    tabIndex={-1}
                    onClick={() => {
                      setCurrentYear((prev) => moment(prev).add(1, "year"));
                    }}
                  >
                    {">"}
                  </button>
                </div>
              )}
              <TabSelector
                options={["Vista mensual", "Vista anual"]}
                selected={selectedTimeView}
                onChange={(e) => {
                  setSelectedTimeView(e);
                  if (e === "Vista mensual") {
                    setCurrentMonth(moment());
                  } else setCurrentYear(moment());
                }}
              />
            </div>
            <ResponsiveContainer
              width="100%"
              height={350}
              style={{
                maxWidth: 1000,
                margin: "0 auto",
              }}
            >
              <BarChart
                width={500}
                height={300}
                barCategoryGap={1}
                barGap={0}
                data={cashClosureData}
                margin={barChartMargin}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" tick={axisStyle} />
                <YAxis tick={axisStyle} />
                <Tooltip content={customTooltip} />
                <Legend />
                <Bar
                  dataKey="total"
                  name="Total"
                  fill={barColors.blue}
                  activeBar={
                    <Rectangle
                      fill={barColors.orange}
                      stroke={barColors.gray}
                    />
                  }
                  onClick={({ name }) => {
                    let startDate, endDate;

                    if (selectedTimeView === "Vista mensual") {
                      // Vista diaria dentro del mes actual
                      const date = moment(
                        `${currentMonth.format("YYYY-MM")}-${name}`,
                        "YYYY-MM-D",
                      ).format("YYYY-MM-DD");

                      startDate = date;
                      endDate = date;
                    } else {
                      // Vista mensual dentro del año actual
                      startDate = moment({
                        year: currentYear.year(),
                        month: name - 1,
                        day: 1,
                      }).format("YYYY-MM-DD");

                      endDate = moment(startDate)
                        .endOf("month")
                        .format("YYYY-MM-DD");
                    }

                    openCashPopup(
                      selectedSalesOptic.id,
                      "estandar",
                      true,
                      startDate,
                      endDate,
                      -1,
                      selectedSalesOptic.name,
                      "",
                    );
                  }}
                />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <ButtonIconH
            text={!expandPanel ? "Expandir" : "Contraer"}
            small={true}
            onClick={() => {
              setExpandPanel((prev) => !prev);
            }}
          ></ButtonIconH>
        </div>
        {expandPanel && (
          <div className="dashboard-content-panel">
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <TabSelector
                options={["Ventas", "Estadísticas"]}
                style={{ borderBottom: "none" }}
                selected={selectedPanelView}
                onChange={(e) => {
                  setSelectedPanelView(e);
                }}
              />
            </div>
            <div className="thin-section-rounded-border">
              {selectedPanelView === "Ventas" && (
                <DashboardSalesPanelSalesView
                  createPopupQuestion={createPopupQuestion}
                  removePopupQuestion={removePopupQuestion}
                />
              )}
              {selectedPanelView === "Estadísticas" && (
                <DashboardSalesPanelStatsView
                  openCashPopup={(
                    selectedOpticId,
                    type,
                    show,
                    startDate,
                    endDate,
                    seeMore,
                    opticName,
                    agentId,
                  ) =>
                    openCashPopup(
                      selectedOpticId,
                      type,
                      show,
                      startDate,
                      endDate,
                      seeMore,
                      opticName,
                      agentId,
                    )
                  }
                />
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
